import React from 'react';

const TaskCard = ({ task, onDelete, onPreview, onOpenErrorDetail }) => {
  const statusLabels = {
    processing: '生成中',
    completed: '已完成',
    failed: '失败',
  };

  const formatTime = (ts) => {
    if (!ts) return '';
    const d = new Date(ts);
    const h = String(d.getHours()).padStart(2, '0');
    const m = String(d.getMinutes()).padStart(2, '0');
    return `${h}:${m}`;
  };

  const mediaUrl = task.videoUrl || task.imageUrl || null;
  const isImage = task.mode === 'image';

  return (
    <div
      className='creator-task-card'
      onClick={() => {
        if (task.status === 'completed' && mediaUrl) {
          onPreview(task);
        }
      }}
    >
      <button
        className='creator-task-card-delete'
        onClick={(e) => {
          e.stopPropagation();
          onDelete(task.id);
        }}
        title='删除任务'
      >
        &times;
      </button>

      <div className='creator-task-card-media'>
        {task.status === 'processing' && (
          <div className='creator-task-processing'>
            <div className='creator-task-spinner' />
            <span className='creator-task-processing-text'>生成中...</span>
          </div>
        )}
        {task.status === 'completed' && mediaUrl && isImage && (
          <img src={mediaUrl} alt={task.prompt} />
        )}
        {task.status === 'completed' && mediaUrl && !isImage && (
          <video src={mediaUrl} muted preload='metadata' />
        )}
        {task.status === 'completed' && !mediaUrl && (
          <span className='task-placeholder'>&#9654;</span>
        )}
        {task.status === 'failed' && (
          <button
            type='button'
            className='creator-task-error-trigger'
            onClick={(e) => {
              e.stopPropagation();
              onOpenErrorDetail?.(task);
            }}
            title={task.error || '生成失败'}
          >
            {task.error || '生成失败'}
          </button>
        )}
        <span className={`creator-task-card-status ${task.status}`}>
          {statusLabels[task.status] || task.status}
        </span>
      </div>

      <div className='creator-task-card-info'>
        <div className='creator-task-card-prompt' title={task.prompt}>
          {task.prompt}
        </div>
        <div className='creator-task-card-meta'>
          <span>{task.model}</span>
          <span>{formatTime(task.createdAt)}</span>
        </div>
      </div>
    </div>
  );
};

export default TaskCard;
